/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import ReactMarkdown from 'react-markdown';
import { bool, func, object } from 'prop-types';
import styles from './styles.module.css';
import StyledButton from '../../../../EnterpriseDesignSystem/Button/StyledButton';
import { trackEvent } from '../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';
import OfferInboxContainer from '../../../GraphqlHomePage/Partials/PersonalizedOfferInbox/OfferInboxContainer';
import { setOfferInboxDrawerOpen } from '../../../../../../state/ducks/App/App-Actions';
import noop from '../../../../../helpers/noop';

// hook
const useOfferCycle = (offers, intervalMs) => {
    const [currentOffer, setCurrentOffer] = React.useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentOffer((prev) => (prev + 1) % offers.length);
        }, intervalMs);
        return () => clearInterval(interval);
    }, [offers, intervalMs]);

    return currentOffer;
};
const SiteWideBannerMultiOffer = ({
    multiBannerData, trackClickThrough, isOfferBoxEnabled, sfCampaign,
}) => {
    useStyles(styles);
    const [isOpen, setIsOpen] = useState(false);
    const showNowButton = useRef(null);
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    const instanceId = 'SiteWideBannerMultiOffer';

    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    const openOfferInbox = () => {
        trackClickThrough();
        dispatch(setOfferInboxDrawerOpen({ [instanceId]: true }));
    };

    const fireGaClickEvent = () => {
        const userGroup = sfCampaign?.campaignResponses?.[0]?.payload?.userGroup;
        if (userGroup) {
            dispatch(trackEvent({
                eventCategory: 'Offer Inbox',
                eventAction: userGroup === 'Test' ? 'Variant' : 'Control',
                eventLabel: 'Banner Impression',
                feature_category: 'Offer Inbox',
                feature_element: userGroup === 'Test' ? 'Variant' : 'Control',
                feature_detail: 'Banner Impression',
            }));
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === 'Alt' || event.key === ' ') {
            event.preventDefault();
            fireGaClickEvent();
            if (isOfferBoxEnabled) {
                openOfferInbox();
                return;
            }
            setIsOpen(!isOpen);
            if (!isOpen) {
                showNowButton.current.querySelector('a').focus();
            }
        }
    };

    const toggleMenu = () => {
        fireGaClickEvent();
        if (isOfferBoxEnabled) {
            openOfferInbox();
            return;
        }
        setIsOpen(!isOpen);
        if (!isOpen) {
            dispatch(trackEvent({
                eventCategory: 'Multiple Offer Unt',
                eventAction: 'Clicks on expand chevron',
                eventLabel: 'chevron',
                feature_detail: 'chevron',
                feature_element: 'Clicks on expand chevron',
                feature_category: 'Multiple Offer Unt',
            }));
        }
    };

    const bannerOffers = multiBannerData?.banner || [];

    const getAlphabetCount = (index) => {
        switch (index) {
            case '0':
                return 'first';
            case '1':
                return 'second';
            case '2':
                return 'third';
            case '3':
                return 'fourth';
            case '4':
                return 'five';
            default:
                return '';
        }
    };
    const currentOffer = useOfferCycle(bannerOffers, 5000);
    const handleOnClick = (link, label, index) => {
        const itemValue = getAlphabetCount(index?.toString());
        dispatch(trackEvent({
            eventCategory: 'Multiple Offer Unt',
            eventAction: `Clicks on ${itemValue} offer in expanded UNT`,
            eventLabel: `${label}-${link}`,
            feature_detail: `${label}-${link}`,
            feature_element: `Clicks on ${itemValue} offer in expanded UNT`,
            feature_category: 'Multiple Offer Unt',
        }));
        setIsOpen(false);
    };

    return (
        <div className={styles.multiOfferDropdown}>
            {/* Offer Inbox */}
            {isOfferBoxEnabled && <OfferInboxContainer instanceId={instanceId} />}

            {/* MULTI BANNER */}
            <div
                className={styles.multiOfferBannerContainer}
                role="button"
                tabIndex={0}
                onClick={toggleMenu}
                onKeyDown={handleKeyDown}
                aria-expanded={isOpen}
                aria-controls="dropdown-menu"
                aria-labelledby="dropdownControl"
                style={{ backgroundColor: multiBannerData.background_color, color: multiBannerData?.font_color || '#ffffff' }}
            >
                <span id="dropdownControl" hidden>Multi-offer dropdown. Get offer details by pressing enter, space bar, option or alt</span>
                {bannerOffers?.map((offer, index) => (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`multi-offer-${index}`}
                        className={`${styles.offer} ${index === currentOffer ? styles.active : ''}`}
                        aria-hidden={index !== currentOffer}
                        aria-current={index === currentOffer ? 'true' : undefined}
                    >
                        <ReactMarkdown>
                            {offer?.shorthand_message}
                        </ReactMarkdown>
                    </div>
                ))}
                <div className={styles.chevron}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="21"
                        height="21"
                        viewBox="0 0 20 20"
                        fill="none"
                        aria-label={isOpen ? 'Close dropdown' : 'Open dropdown'}
                    >
                        <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M15.4419 7.55806C15.686 7.80214 15.686 8.19786 15.4419 8.44194L10.4419 13.4419C10.1979 13.686 9.80214 13.686 9.55806 13.4419L4.55806 8.44194C4.31398 8.19786 4.31398 7.80214 4.55806 7.55806C4.80214 7.31398 5.19786 7.31398 5.44194 7.55806L10 12.1161L14.5581 7.55806C14.8021 7.31398 15.1979 7.31398 15.4419 7.55806Z"
                            fill={multiBannerData?.font_color || '#ffffff'}
                        />
                    </svg>
                </div>

            </div>
            {/* SLIDE DROPDOWN */}
            {isOpen && (
                <div
                    className={`${styles.multiOfferDropdownContainer} ${isOpen ? styles.multiOfferDropdownContainerOpen : ''}`}
                    id="dropdown-menu"
                    role="region"
                    aria-hidden={!isOpen}
                >
                    <div ref={wrapperRef} className={`${styles.multiOfferDropdownInnerContainer} ${isOpen ? styles.multiOfferDropdownInnerContainerOpen : ''}`}>
                        <div className={styles.dropdownContentContainer}>
                            {bannerOffers.map((dropdownOffer, index) => (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className={styles.dropdownOfferContainer} key={`dropdownOffer-${index}`}>
                                    <h3 className={styles.titleOffer}>{dropdownOffer.message_heading}</h3>
                                    <ReactMarkdown className={styles.contentOffer}>{dropdownOffer.message}</ReactMarkdown>
                                    {index === 0 ? (
                                        <div id={`ref-${index}`} ref={showNowButton}>
                                            <StyledButton
                                                label={dropdownOffer.cta.link.title}
                                                variant="text-only"
                                                size="sm"
                                                link={dropdownOffer.cta.link.href}
                                                handleOnClick={() => handleOnClick(dropdownOffer.cta.link.href, dropdownOffer.cta.title, index)}
                                                attributes={{ 'aria-label': `${dropdownOffer.ariaLabel}`, tabindex: isOpen ? 0 : -1 }}
                                            />
                                        </div>
                                    ) : (
                                        <StyledButton
                                            label={dropdownOffer.cta.link.title}
                                            variant="text-only"
                                            size="sm"
                                            link={dropdownOffer.cta.link.href}
                                            handleOnClick={() => handleOnClick(dropdownOffer.cta.link.href, dropdownOffer.cta.title, index)}
                                            attributes={{ 'aria-label': `${dropdownOffer.ariaLabel}`, tabindex: isOpen ? 0 : -1 }}
                                        />
                                    )}

                                </div>
                            ))}
                        </div>
                        <button
                            type="button"
                            onClick={toggleMenu}
                            onKeyDown={handleKeyDown} // if on hit any key it should close
                            className={styles.closeMultiOfferDropdown}
                            aria-label="Close offer dropdown and continue"
                            tabIndex={isOpen ? 0 : -1}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="35"
                                height="35"
                                viewBox="0 0 24 25"
                                fill="none"
                                aria-label="Close dropdown"
                            >
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M5.46967 5.71589C5.76256 5.42299 6.23744 5.42299 6.53033 5.71589L12 11.1856L17.4697 5.71589C17.7626 5.42299 18.2374 5.42299 18.5303 5.71589C18.8232 6.00878 18.8232 6.48365 18.5303 6.77655L13.0607 12.2462L18.5303 17.7159C18.8232 18.0088 18.8232 18.4837 18.5303 18.7765C18.2374 19.0694 17.7626 19.0694 17.4697 18.7765L12 13.3069L6.53033 18.7765C6.23744 19.0694 5.76256 19.0694 5.46967 18.7765C5.17678 18.4837 5.17678 18.0088 5.46967 17.7159L10.9393 12.2462L5.46967 6.77655C5.17678 6.48365 5.17678 6.00878 5.46967 5.71589Z"
                                    fill="#2F363D"
                                />
                            </svg>
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};
SiteWideBannerMultiOffer.propTypes = {
    multiBannerData: object.isRequired,
    trackClickThrough: func,
    isOfferBoxEnabled: bool,
    sfCampaign: object,
};

SiteWideBannerMultiOffer.defaultProps = {
    trackClickThrough: noop,
    isOfferBoxEnabled: false,
    sfCampaign: null,
};

export default SiteWideBannerMultiOffer;
